import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export default function AdminRoute({ children }) {
  const { user, loading, authenticated } = useAuth();

  if (loading) return null;

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  const isAdmin = user?.roles?.includes("ROLE_ADMIN");

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}